/*
 * Models and Collections for Category codes (technically category bindings to a response)
 */

define(["backbone"], function (Backbone) {
  "use strict";

  const TopicCategoriesModel = {};

  TopicCategoriesModel.topicCategoryBk = Backbone.Model.extend({
    idAttribute: "categoryId",
    defaults: {
      categoryId: 0,
      description: "",
    },
    getValues: function () {
      return this.get("categoryValues");
    },
  });

  TopicCategoriesModel.topicCategoriesBk = Backbone.Collection.extend({
    model: TopicCategoriesModel.topicCategoryBk,
    comparator: function (a, b) {
      const comparison = Backbone.textComparator(a, b, "categoryName");
      if (comparison === 0) {
        return Backbone.textComparator(a, b, "value");
      } else {
        return comparison;
      }
    },
  });

  TopicCategoriesModel.topicCategoryValue = Backbone.Model.extend({
    idAttribute: "categoryValueId",
  });

  TopicCategoriesModel.topicCategoryValues = Backbone.Collection.extend({
    model: TopicCategoriesModel.topicCategoryValue,
    comparator: function (a, b) {
      return Backbone.textComparator(a, b, "value");
    },
  });

  TopicCategoriesModel.topicCategory = Backbone.Model.extend({
    idAttribute: "categoryBindingId",
    defaults: {
      categoryName: "",
      categoryValue: "",
      categoryDescription: "",
      categoryValueDescription: "",
    },
    select: function (selectedValue) {
      if (this.selected && !selectedValue) {
        this.selected = selectedValue;
        this.trigger("deselect");
      } else if (selectedValue && !this.selected) {
        this.selected = selectedValue;
        this.trigger("select");
      }
    },
  });

  TopicCategoriesModel.topicCategories = Backbone.Collection.extend({
    model: TopicCategoriesModel.topicCategory,
    addCategory: function (catId, catName, catValId, catVal, catDesc, catValDesc) {
      //to the collection
      const newCat = new TopicCategoriesModel.topicCategory({
        categoryId: catId,
        categoryName: catName,
        categoryValueId: catValId,
        categoryValue: catVal,
        categoryDescription: catDesc,
        categoryValueDescription: catValDesc,
      });
      this.add(newCat, { at: 0 });
      return newCat;
    },
    comparator: function (a, b) {
      const comparison = Backbone.textComparator(a, b, "categoryName");
      if (comparison === 0) {
        return Backbone.textComparator(a, b, "categoryValue");
      } else {
        return comparison;
      }
    },
    _buildPathToResponseMap: function (map, path, conversationNode) {
      const currentPath = path + conversationNode.get("description");
      map[currentPath] = conversationNode.get("responseId");
      conversationNode.decisionCol.each(function (node) {
        this._buildPathToResponseMap(map, currentPath + "  ", node);
      }, this);
    },
  });

  return TopicCategoriesModel;
});
